import { io } from "socket.io-client";

let currentToken = '';

const socket = io(process.env.REACT_APP_SOCKET_URL || "http://localhost:4000", {
  withCredentials: true,
  autoConnect: false,                        // connect only after login
  auth: (cb) => cb({ token: currentToken }), // evaluated on every (re)connect
});

export const setSocketToken = (token) => {
  currentToken = token || '';
};

// kept for compatibility with your earlier version
export const updateSocketToken = setSocketToken;
export const connectSocket = (token) => {
  setSocketToken(token);
  if (!socket.connected) socket.connect();
};

export default socket;